import {
	comMapping
} from "@/components/util/Function/comMapping";
export function getdata() {
	let obj = {
		formdata: {
			implementation: "",
			name: "",
			cron: ""
		},
		formlist: [{
				prop: "implementation",
				label: "任务描述	",
				type: "select",
				selectval: [],
				isnotnull: true,
			},
			{
				prop: "name",
				label: "实例名称	",
				type: "input",
				isnotnull: true,

			},
			{
				prop: "cron",
				label: "定时参数	",
				type: "input",
				isnotnull: true
			}
		],
		headData: [{
				title: "任务描述",
				prop: "implementation",
				width: "150",
				custom: true
			},
			{
				title: "实例名称",
				prop: "name",
				width: "150"
			},
			{
				title: "状态",
				prop: "status",
				width: "150",
				custom: true
			},
			{
				title: "最后一次执行时间",
				prop: "lastTime",
				width: "150"
			},
			{
				title: "定时参数",
				prop: "cron",
				width: "150"
			},
			{
				title: "启动信息",
				prop: "message",
				width: "150"
			},
			{
				title: "操作人",
				prop: "operator",
				width: "150"
			},
			{
				title: "修改时间",
				prop: "tes8",
				width: "150"
			}, {
				title: "操作",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
